import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getPopularTags = (page = 1, perPage = 10) => {
  const params = toParams({
    type: 'popular',
    page,
    perPage,
  });
  return API.get(`/tags/?${params}`);
};

const getStoriesByTag = (id, ordering = 'popular', page = 1, perPage = 20) => {
  const params = toParams({
    page,
    perPage,
    ordering,
  });
  return API.get(`/tags/${id}/stories/?${params}`);
};

const getRecommendedTags = (page = 1, perPage = 10) => {
  const params = toParams({
    type: 'reco',
    page,
    perPage,
  });
  return API.get(`/tags/?${params}`);
};

const getTagRanking = () => API.get('/ranking/tags/');

const createTag = (name) => API.post('/tags/', { name });

export default {
  getPopularTags,
  getStoriesByTag,
  getRecommendedTags,
  getTagRanking,
  createTag,
};



// WEBPACK FOOTER //
// ./src/app/apis/tag.js